import React from 'react';
import { Helmet } from 'react-helmet-async';

const BreadcrumbSchema = ({ currentPage, description }) => {
  // Все возможные хлебные крошки для сайта
  const allBreadcrumbs = {
    home: {
      name: 'Главная',
      url: 'https://lametri.ru/',
    },
    about: {
      name: 'О проекте',
      url: 'https://lametri.ru/about',
    },
    howto: {
      name: 'Инструкция',
      url: 'https://lametri.ru/howto',
    },
    questions: {
      name: 'Анализ',
      url: 'https://lametri.ru/questions',
    },
    orderRequest: {
      name: 'Результаты запросов',
      url: 'https://lametri.ru/orderRequest',
    },
  };

  // Выбираем нужные крошки в зависимости от текущей страницы
  let breadcrumbs = [];

  // Всегда добавляем главную страницу
  breadcrumbs.push(allBreadcrumbs.home);

  // Добавляем другие страницы
  switch (currentPage) {
    case 'about':
      breadcrumbs.push(allBreadcrumbs.about);
      break;
    case 'howto':
      breadcrumbs.push(allBreadcrumbs.howto);
      break;
    case 'questions':
      breadcrumbs.push(allBreadcrumbs.questions);
      break;
    case 'orderRequest':
      breadcrumbs.push(allBreadcrumbs.orderRequest);
      break;
    default:
      // Если страница не указана, оставляем только "Главную"
      break;
  }

  // Формируем JSON-LD
  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbJsonLd)}
      </script>
      <meta name="description" content={description} />
    </Helmet>
  );
};

export default BreadcrumbSchema;
